import { render, staticRenderFns } from "./Super.vue?vue&type=template&id=22458e54&scoped=true&"
import script from "./Super.vue?vue&type=script&lang=js&"
export * from "./Super.vue?vue&type=script&lang=js&"
import style0 from "./Super.vue?vue&type=style&index=0&id=22458e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22458e54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22458e54')) {
      api.createRecord('22458e54', component.options)
    } else {
      api.reload('22458e54', component.options)
    }
    module.hot.accept("./Super.vue?vue&type=template&id=22458e54&scoped=true&", function () {
      api.rerender('22458e54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dashboard/Super.vue"
export default component.exports